import ApiService from '@/common/api.service'

export default {
  save (memberNote) {
    return new Promise((resolve, reject) => {
      ApiService.post('/member-note/save', memberNote).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  get (type) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/member-note/get?type=${type}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getAll (id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/member-note/get-all/${id}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
